var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "role" },
    [
      _c(
        "el-container",
        [
          _c("div", { staticClass: "role-list-container" }, [
            _c("div", { staticClass: "role-title" }, [
              _c("div", { staticClass: "title-name" }, [_vm._v("角色列表")]),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-plus",
                        size: "mini",
                        plain: "",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.handleAdd()
                        }
                      }
                    },
                    [_vm._v("新增角色")]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "role-list" },
              [
                _c(
                  "el-scrollbar",
                  [
                    _c(
                      "el-aside",
                      {
                        staticStyle: {
                          "background-color": "rgb(238, 241, 246)"
                        },
                        attrs: { width: "210px" }
                      },
                      [
                        _vm.roleList.length != 0
                          ? _c(
                              "el-menu",
                              {
                                attrs: {
                                  "default-active": _vm.currentRole.roleId + ""
                                },
                                on: { select: _vm.selectRole }
                              },
                              _vm._l(_vm.roleList, function(item) {
                                return _c(
                                  "el-menu-item",
                                  {
                                    key: item.roleId,
                                    attrs: { index: item.roleId + "" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "list-item",
                                        attrs: { slot: "title" },
                                        slot: "title"
                                      },
                                      [
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "comp-node--name" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.roleName) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "comp-btns-wrap" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.handleEditRole(
                                                      item
                                                    )
                                                  }
                                                }
                                              }),
                                              item.status != 0
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-delete",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.handleDel(
                                                          item.roleId
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      ],
                                      2
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "el-container",
            [
              _c(
                "el-main",
                { staticClass: "role-content-main" },
                [
                  _c("div", { staticClass: "role-notes" }, [
                    _c("div", { staticClass: "role-name" }, [
                      _vm._v(_vm._s(_vm.currentRole.roleName))
                    ]),
                    _c("div", { staticClass: "role-detail" }, [
                      _vm._v(_vm._s(_vm.currentRole.remark))
                    ])
                  ]),
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.activeName,
                        callback: function($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "角色成员", name: "first" } },
                        [
                          _c("RoleMembers", {
                            attrs: {
                              roleId: _vm.currentRole.roleId,
                              roleEmp: _vm.RoleEmpMenuId.roleEmp
                            },
                            on: { reGet: _vm.reGet }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "功能权限", name: "second" } },
                        [
                          _c("Authority", {
                            attrs: {
                              roleId: _vm.currentRole.roleId,
                              roleEmp: _vm.RoleEmpMenuId.roleEmp,
                              empMenuId: _vm.RoleEmpMenuId.empMenuId
                            },
                            on: { reGet: _vm.reGet }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("AddRole", {
        ref: "AddRole",
        on: { createSuccess: _vm.createSuccess }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }